import React, { HTMLAttributes, ReactNode } from "react";
import styled, { css } from "styled-components";
import {
  FontColor,
  FontSize,
  FontStyle, FontWeight,  theme
} from "../config/theme";

interface TextProps extends HTMLAttributes<HTMLParagraphElement> {
  as?:         keyof JSX.IntrinsicElements;
  href?:       string;
  lineHeight?: string;
  show?:       boolean;
  style?:      React.CSSProperties;
  color?:      FontColor | string;
  size?:       FontSize | string;
  weight?:     FontWeight;
  fontStyle?:  FontStyle;
  onClick?:    (e?: any) => void;
  children?:   ReactNode;
  truncated?:  boolean;
  capitalized?: boolean;
  type?:       'span' | 'p' | 'a';
};

const TextComponent = styled.div<TextProps>`
  line-height: ${(props) => props.lineHeight};
  font-size:   ${(p) => p.size ? `${theme.font.size[p.size]}` : `${theme.font.size.default}`};
  font-weight: ${(p) => `${theme.font.weight[p.weight]}`};
  font-style:  ${(p) => `${theme.font.style[p.fontStyle]}`};
  color:  ${(p) => p.color in theme.font.color ? `${theme.font.color[p.color as FontColor]}` : p.color || `${theme.font.color.black}`};
  text-decoration: none;
  text-transform: ${(p) => p.capitalized && "capitalize"};
  

  ${p => p.truncated === true && css`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  `}
`;

export const Text = ({
  children,
  size,
  type = 'p',
  ...props
}: TextProps) => {
    return (
      <TextComponent size={size} as={type} {...props}>
        {children}
      </TextComponent>
    );
  }
